import PropTypes from 'prop-types';

import CardResource from '../card-resource';
import ModalBasic from '../../../atoms/modal-basic';
import useMoneyMarketHoldings from '../../../../stores/profile/modules/use-money-market-holdings';

import { className } from '../../../../utils/GlobalCssProxy';
import format from '../../../../utils/format';

const CardResourceMoneyMarketHoldings = ({
  bottomLink,
  buttonText = 'Historical Money Market Holdings'
}) => {
  const { isModalVisible, handleShow, handleClose, reports } = useMoneyMarketHoldings();

  return (
    <>
      <CardResource.ModalControl
        titleText="Holdings Reports"
        buttonText={buttonText}
        iconVariant="Document"
        bottomLink={bottomLink}
        onClick={handleShow}
      />
      <ModalBasic show={isModalVisible} onHide={handleClose}>
        <ModalBasic.Header>
          <ModalBasic.Title>
            Holdings Reports
            <ModalBasic.Subtitle>Historical Money Market Holdings</ModalBasic.Subtitle>
          </ModalBasic.Title>
          <ModalBasic.CloseButton onClick={handleClose} />
        </ModalBasic.Header>
        <ModalBasic.Body>
          <p {...className('paragraph-standard')}>
            The list below contains links to the monthly holdings reports for this account for the
            month(s) listed. The monthly holdings report contains a complete listing of the holdings
            for this account for each period.
          </p>
          {reports.length < 1 ? (
            <p {...className('paragraph-standard')}>
              Holding Reports are currently unavailable for this account.
            </p>
          ) : (
            <ul {...className('list-unstyled')}>
              {reports.map((report, index) => {
                return (
                  <li
                    data-key={`${report.pdfDate || ''}-${index}`}
                    key={`${report.pdfDate || ''}-${index}`}
                    {...className(
                      'border-top',
                      'list-group-item',
                      index === reports.length - 1 && 'border-bottom'
                    )}
                  >
                    <a
                      href={report.pdfLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      {...className('text-black', 'd-block', 'm-3', 'font-weight-bold')}
                    >
                      {format.date(report.pdfDate)} | {report.pdfName}
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
        </ModalBasic.Body>
      </ModalBasic>
    </>
  );
};

CardResourceMoneyMarketHoldings.propTypes = {
  bottomLink: PropTypes.string,
  buttonText: PropTypes.string
};

export default CardResourceMoneyMarketHoldings;
